<template>
  <div class="home">
    <section class="sectionClass">
      <div class="headBox">
        <div class="box">
          <div class="b1">
            <img src="/static/logo1.png" alt="">
            <div class="b11">
              <div class="b111" :class="path == '/index' ? 'b112' : ''" @click="jump('/index')">
                <div class="b1111">首页</div>
                <div class="b1112"></div>
              </div>
              <div class="b111" :class="path == '/college' || path == '/collegeDetail' ? 'b112' : ''"
                @click="jump('/college')">
                <div class="b1111">学院</div>
                <div class="b1112"></div>
              </div>
              <div class="b111" :class="path == '/engineer' || path == '/engineerDetail' ? 'b112' : ''"
                @click="jump('/engineer')">
                <div class="b1111">工程师</div>
                <div class="b1112"></div>
              </div>
              <div class="b111" :class="path == '/enterprise' || path == '/enterpriseDetail' ? 'b112' : ''"
                @click="jump('/enterprise')">
                <div class="b1111">工控企业</div>
                <div class="b1112"></div>
              </div>
              <div class="b111"
                :class="path == '/recruitment' || path == '/recruitmentDetail' || path == '/applyRecruitment' ? 'b112' : ''"
                @click="jump('/recruitment')">
                <div class="b1111">招聘信息</div>
                <div class="b1112"></div>
              </div>
              <div class="b111" :class="path == '/job' ? 'b112' : ''" @click="jump('/job')">
                <div class="b1111">求职信息</div>
                <div class="b1112"></div>
              </div>
              <!-- <div class="b111" :class="path == '/webVideo' ? 'b112' : ''" @click="jump('/webVideo')">
                <div class="b1111">网络视频</div>
                <div class="b1112"></div>
              </div> -->
            </div>
          </div>
          <div class="b2">
            <div class="b21" @click="$refs.show.click()">
              <img src="/static/index/index2.png" alt="">
              <div>APP</div>
            </div>
            <div v-if="aid" class="b24" @click="jump('/user')">
              <img src="/static/index/index20.png" alt="">
              <div>{{ name }}</div>
            </div>
            <div v-if="!aid" class="b22" :class="path == '/login' ? 'b23' : ''" @click="jump('/login')">登录</div>

            <div v-if="!aid" class="b22" :class="path == '/registered' ? 'b23' : ''" @click="jump('/registered')">注册
            </div>
          </div>
        </div>
      </div>
      <router-view></router-view>

    </section>
    <!-- <el-dialog
        title="扫一扫下载APP"
        :visible.sync="dialogVisible"
        width="560px"
        :before-close="no">
        <div class="imgShow">
          <div>
            <img src="/static/index/index19.png" alt="">
            <div>工程师e家APP</div>
          </div>
        </div>
      </el-dialog> -->
    <show ref="show"></show>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Cookie from "js-cookie";
import show from '../../components/show.vue';
export default {
  components: { show },
  data() {
    return {
      path: '',
      aid: '',
      name: '',
      dialogVisible: false
    };
  },
  computed: {
    ...mapState({
    }),
  },
  methods: {
    ...mapActions([]),
    no() {
      this.dialogVisible = false
    },
    jump(e) {
      this.$router.push(e)
    },
    exit() {
      // this.$confirm(`确定要退出登录吗？`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {
      //     Cookie.set('id','')
      //     Cookie.set('name','')
      //     this.$router.push('/login')
      //   })
      //   .catch(() => {});
    }
  },
  mounted() {
    this.path = this.$route.path
    if (Cookie.get('id')) {
      this.aid = Cookie.get('id')
      this.name = Cookie.get('name')

      let params = {
        aid: Cookie.get('id'),
        type: 'PC'
      };

      this.$axios
        .post('https://www.gcsej.cn/gcsej/app/do_online_count', this.$qs.stringify(params)).then(res => {
          console.log(res)
        })

    } else {
      this.aid = ''
    }
  },
  updated() {
    this.path = this.$route.path
    if (Cookie.get('id')) {
      this.aid = Cookie.get('id')
      this.name = Cookie.get('name')
    } else {
      this.aid = ''
    }
  },
};
</script>
<style lang="scss" scoped>
.imgShow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 293px;
  border-top: 1px solid #CCCCCC;

  &>div {

    img {
      width: 168px;
      height: 168px;
      margin: 0 auto 16px;
    }

    div {
      font-size: 18upx;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
  }

  .i1 {
    margin-right: 129px;
  }
}

.headBox {
  width: 100%;
  min-width: 1250px;
  position: relative;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 1);
}

.box {
  width: 1200px;
  height: 94px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .b1 {
    display: flex;
    align-items: center;

    &>img {
      width: 50px;
      height: 50px;
      margin-right: 30px;
    }

    .b11 {
      display: flex;
      align-content: center;

      .b111 {
        margin-right: 50px;
        cursor: pointer;

        .b1111 {
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          margin-bottom: 2px;
        }

        .b1112 {
          width: 100%;
          height: 2px;
          background: transparent;
        }
      }

      .b112 {
        .b1111 {
          color: #198AFA;
        }

        .b1112 {
          background: #198AFA;
        }
      }
    }
  }

  .b2 {
    display: flex;
    align-items: center;

    .b21 {
      margin-right: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;

      div {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }

      img {
        width: 16px;
        height: 22px;
        margin-right: 6px;
      }
    }

    .b22 {
      width: 72px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #979797;
      text-align: center;
      line-height: 30px;
      margin-right: 20px;
      cursor: pointer;
    }

    .b23 {
      border: 1px solid #198AFA;
      background: #198AFA;

      color: #FFFFFF;
    }

    .b24 {
      display: flex;
      align-items: center;
      margin-right: 20px;

      img {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }

      div {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
      }
    }
  }

}

.home {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 60px;
    background: #545c64;
    display: flex;
    color: white;
    justify-content: center;
    align-items: center;

    .el-dropdown {
      font-size: 12px;
      height: 65px;
      color: white;
    }

    &>div {
      width: 50%;
      height: 100%;
      float: left;
      line-height: 60px;
      font-size: 24px;
    }

    &>div:first-of-type {
      padding-left: 50px;
    }

    &>div:last-of-type {
      text-align: right;
      padding-right: 50px;

      &>span:last-of-type {
        font-weight: 600;
      }
    }
  }

  .el-dropdown-menu .el-popper {
    top: 59px !important;
  }

  .sectionClass {
    // overflow-y: auto;
    //  height: 100%;
    width: 100%;
    //  padding-top: 94px;
    display: flex;
    flex-direction: column;
    background: #F8F8F8;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue